import { Card, CardBody, Icon } from '@acpaas-ui/react-components';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes, useLocation, useMatch, useNavigate } from 'react-router-dom';
import { set } from '../../../../actions/breadcrumbs.actions';
import { ADMIN_ORGANIZATIONS_BREADCRUMBS } from '../../../../constants/breadcrumbs.constants';
import {
  ADMIN_ORGANIZATIONS_PATHS,
  ADMIN_PATH,
  ADMIN_SCHOOLS_PATHS,
  ADMIN_TAB_PATHS
} from '../../../../constants/paths.constants';
import { useAdminRouteGuard } from '../../../../hooks/admin/useAdminRouteGuard.hook';
import AdminOrganizationsPartners from './AdminOrganizationsPartners';
import AdminSchoolAgodiBranch from './schools/AdminSchoolAgodiBranch';
import AdminSchoolAgodiBranches from './schools/AdminSchoolAgodiBranches';
import AdminSchoolBranches from './schools/AdminSchoolBranches';
import AdminSchoolCommunities from './schools/AdminSchoolCommunities';
import AdminSchoolManagements from './schools/AdminSchoolManagements';
import AdminSchools from './schools/AdminSchools';
import AdminSchoolSchools from './schools/AdminSchoolSchools';

const AdminOrganizations = () => {
  const dispatch = useDispatch();
  const pathname = useLocation().pathname;
  const pathMatch = useMatch(`${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}/*`);
  const navigate = useNavigate();

  useAdminRouteGuard();

  useEffect(() => {
    if (pathMatch.params['*']?.split('/')?.filter((p) => !!p).length === 1) {
      dispatch(set(ADMIN_ORGANIZATIONS_BREADCRUMBS.LOADED({ pathname })));
    }
  }, [dispatch, pathMatch, pathname]);

  const getNavigateForTab = (tab) => () => {
    navigate(`${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${tab.path}`);
  };

  const Overview = (
    <div className="spo-o-admin-organizations">
      <div className="row">
        {Object.values(ADMIN_ORGANIZATIONS_PATHS).map((tab) => (
          <div
            key={tab.path}
            onClick={getNavigateForTab(tab)}
            className="spo-o-admin-organizations__card-wrapper col-xs-12 col-lg-6"
          >
            <Card>
              <CardBody>
                <h5>{tab.name}</h5>
                <Icon name="ai-arrow-right-1" />
              </CardBody>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <Routes>
      <Route index element={Overview} />
      <Route path={ADMIN_ORGANIZATIONS_PATHS.PARTNERS.path} element={<AdminOrganizationsPartners />} />
      <Route path={`${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}`} element={<AdminSchools />} />
      <Route
        path={`${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.MANAGEMENT.path}`}
        element={<AdminSchoolManagements />}
      />
      <Route
        path={`${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.COMMUNITIES.path}`}
        element={<AdminSchoolCommunities />}
      />
      <Route
        path={`${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.SCHOOLS.path}`}
        element={<AdminSchoolSchools />}
      />
      <Route
        path={`${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.BRANCHES.path}`}
        element={<AdminSchoolBranches />}
      />
      <Route
        path={`${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.AGODI_BRANCHES.path}`}
        element={<AdminSchoolAgodiBranches />}
      />
      <Route
        path={`${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.AGODI_BRANCH_DETAILS.path}`}
        element={<AdminSchoolAgodiBranch />}
      />
    </Routes>
  );
};

export default AdminOrganizations;
